import React from 'react';
import { useHistory } from 'react-router-dom';

import { routeHelper } from 'src/app/helpers';
import { LicenseLayoutPropsType } from 'src/app/layouts/LicenseLayout/license-layout.config';

import styles from 'src/app/layouts/LoginLayout/LoginLayout.module.scss';

const LicenseLayout: React.FC<LicenseLayoutPropsType> = ({ children }) => {
  const history = useHistory();
  const handleOnClickLogo = () => {
    routeHelper.handleRoute(history, '/');
  };

  return (
    <div className={styles.container}>
      <div
        style={{
          background: 'url(/assets/loginBackground.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
        className={styles.leftSection}
      >
        {children}
      </div>
    </div>
  );
};

export default LicenseLayout;
